import { ACTIONS } from "./actions";

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_THEME: {
      return {
        ...state,
        theme: action.value,
      };
    }
    case ACTIONS.SET_PLAYING: {
      return {
        ...state,
        music: { ...state.music, isPlaying: !state.music.isPlaying },
      };
    }
    case ACTIONS.SET_SONG: {
      return {
        ...state,
        music: { ...state.music, song: action.value },
      };
    }
    case ACTIONS.SET_VOLUME: {
      return {
        ...state,
        music: { ...state.music, volume: action.value },
      };
    }
    case ACTIONS.SET_HOVERED: {
      return {
        ...state,
        hovered: action.value,
      };
    }

    case ACTIONS.SELECT_OBJECT: {
      return {
        ...state,
        selectedObject: action.value,
      };
    }
    case ACTIONS.OPEN_DRAWER: {
      return {
        ...state,
        drawer: {
          ...state.drawer,
          ...action.value,
          isOpen: true,
        },
        selectedObject: null,
      };
    }
    case ACTIONS.CLOSE_DRAWER: {
      return {
        ...state,
        drawer: {
          ...state.drawer,
          isOpen: false,
        },
        selectedObject: null,
      };
    }
    case ACTIONS.SET_DRAWER_CONTENT: {
      return {
        ...state,
        drawer: {
          ...state.drawer,
          content: action.value,
        },
        selectedObject: null,
      };
    }

    default:
      return state;
  }
};
